define('home/viewmodels/DiscussionViewModel',[
    'underscore',
    'backbone',

    'core/UniqueModel',

    'home/collections/common/SelectiveCollection',
    'home/models/ChannelProfile',
    'home/models/ChannelProfileFeed',
], function (
    _,
    Backbone,

    UniqueModel,

    SelectiveCollection,
    ChannelProfile,
    ChannelProfileFeed
) {
    'use strict';

    // Implement a Unique DiscussionViewModel by the related Thread model.
    var pool = {};

    var parent = Backbone.Model;
    var parentProto = parent.prototype;

    var DiscussionViewModel = parent.extend({
        initialize: function (_attributes, options) {
            this.thread = options.thread;

            // Sometimes the channel is passed in via options.channel.
            // This occurs primarily when a user clicks onto a discussion
            // page for a "network thread" from a channel feed.
            // If not, check if the thread's forum has a channel once it's
            // fetched.
            this.channel = options.channel || this.thread.forum.channel;
            if (!this.channel && this.thread.shouldFetch()) {
                this.listenToOnce(this.thread, 'sync', function () {
                    this.channel = this.thread.forum.channel;
                    this.trigger('changeRelated:channel');
                });
            }

            this.channels = new UniqueModel(ChannelProfileFeed, {
                listName: ChannelProfileFeed.LIST_NAMES.promoted,
            });

            this.buildRelatedCollections();
        },

        buildRelatedCollections: function () {
            if (!this.channel)
                return;

            var channelProfile = new UniqueModel(
                ChannelProfile,
                {
                    id: this.channel.id,
                    channel: this.channel,
                }
            );
            channelProfile.ensureFetchedTopActivities();
            var relatedThreads = channelProfile.topActivities.get('items');
            var self = this;

            // Builds the collection of 5 related threads shown in the cover area.
            // Ensures that the collection does not contain the current thread.
            this.coverRelatedCollection = new SelectiveCollection(undefined, {
                toSelect: relatedThreads,
                maxSize: 5,
                shouldSelect: function (activityFeedItem) {
                    // Feature if it's not the same as the thread
                    // currently shown on page
                    return activityFeedItem.thread !== self.thread;
                },
                order: function (collection) {
                    return collection.shuffle();
                },
            });
        },

        /**
         * Tries to determines if the thread is generated by the embed or through a manual user entry.
         *
         * @returns {boolean} `true` if we certainly know thread is a network thread,
         *                    `false` otherwise (user-generated, indeterminate etc.).
         */
        isKnownToBeNetworkThread: function () {
            return this.thread.has('isUserGenerated') && !this.thread.get('isUserGenerated');
        },

        ensureFetched: function () {
            this.channels.ensureFetched();
            this.ensureFetchedChannel();
        },

        ensureFetchedChannel: function () {
            if (this.channel)
                this.channel.ensureFetchedWithCounters();
            else
                this.listenTo(this, 'changeRelated:channel', this.ensureFetchedChannel);
        },

        toJSON: function (options) {
            return _.defaults({
                thread: this.thread.toJSON(),
            }, parentProto.toJSON.call(this, options));
        },
    }, {
        getOrCreate: function (attrs, options) {
            var thread = options && options.thread;

            // Can't use thread id because we may not have it at this point, we may have thread slug
            // and forum shortname. But since thread uses UniqueModel, should work to use thread.cid
            // to ensure uniqueness of DiscussionViewModel. In worst case, we fetch the view model
            // multiple times, but nothing should break.
            var existing = thread && pool[thread.cid];

            if (existing)
                return existing;

            var model = new DiscussionViewModel(attrs, options);

            if (thread)
                pool[thread.cid] = model;

            model.ensureFetched();

            return model;
        },
    });

    return DiscussionViewModel;
});

